import { createAsyncThunk } from "@reduxjs/toolkit";
import { CONFIGURATIONS } from "../../config/envConfig";

let API_BASE_URL = CONFIGURATIONS.REACT_APP_CLODUFLARE_URL;

export const uploadToCloudflare = createAsyncThunk(
    "cloudflare/uploadFile",
    async ({ file }, thunkAPI) => {
        try {
            const UPLOAD_URL = `${API_BASE_URL}/tickets/`;
            const API_KEY = CONFIGURATIONS.UPLOAD_API_KEY;

            if (!API_KEY) {
                return thunkAPI.rejectWithValue("Missing upload API key.");
            }

            if (!file || !(file instanceof File)) {
                return thunkAPI.rejectWithValue("Invalid file provided");
            }

            const formData = new FormData();
            formData.append("file", file);

            const response = await fetch(UPLOAD_URL, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${API_KEY}`,
                },
                body: formData,
            });

            const contentType = response.headers.get("content-type");
            let data;

            if (contentType && contentType.includes("application/json")) {
                data = await response.json();
            } else {
                const text = await response.text();
                throw new Error(text || "Upload failed");
            }

            if (!response.ok || !data?.url) {
                return thunkAPI.rejectWithValue(data?.message || "Upload failed");
            }

            return data;
        } catch (err) {
            return thunkAPI.rejectWithValue(err.message || "Upload error");
        }
    }
);

 

// export const fetchMediaMeta = createAsyncThunk(
//     "cloudflare/fetchFileMeta",
//     async ({ key, type = "images" }, thunkAPI) => {
//         const API_KEY = CONFIGURATIONS.UPLOAD_API_KEY;

//         try {
//             if (type === "tracks") {
//                 key = `play/${key}`;
//             }
//             const res = await fetch(`https://supremeedits.com/${type}/${key}`, {
//                 method: "GET",
//                 headers: {
//                     Authorization: `Bearer ${API_KEY}`,
//                 },
//             });

//             if (!res.ok) {
//                 const errMessage = await res.text();
//                 throw new Error(errMessage || "File not found or unauthorized");
//             }

//             return { res };
//         } catch (err) {
//             return thunkAPI.rejectWithValue(err.message);
//         }
//     }
// );




